module.exports = __webpack_public_path__ + "static/media/title-congra.deb4f75c.png";